import { createContext, useContext, useState } from 'react'

interface DisclosureContextType {
  showing: boolean
  setShowing: (value: boolean) => void
}

export const DisclosureContext = createContext<DisclosureContextType>({
  showing: false,
  setShowing: () => {}
})

export const useDisclosure = () => {
  const context = useContext(DisclosureContext)
  return context
}

export const DisclosureProvider = ({ children }: { children: React.ReactNode }) => {
  const [showing, setShowing] = useState<boolean>(false)

  return (
    <DisclosureContext.Provider value={{ showing, setShowing }}>
      {children}
    </DisclosureContext.Provider>
  )
}

export default DisclosureProvider
